import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { PlanOfCareQuestionnaireItem } from './questionnaire'

// Plan of care section questionnaire item to answer type mapping
export const PLAN_OF_CARE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE]: QuestionnaireAnswerType.GROUP,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_GOALS]: QuestionnaireAnswerType.GROUP,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_GOALS_GOAL]: QuestionnaireAnswerType.INTEGER,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS]: QuestionnaireAnswerType.GROUP,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO]:
    QuestionnaireAnswerType.GROUP,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INTERVENTION]:
    QuestionnaireAnswerType.INTEGER,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_CATEGORY]:
    QuestionnaireAnswerType.STRING,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_GOAL]:
    QuestionnaireAnswerType.STRING,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TASK]:
    QuestionnaireAnswerType.STRING,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INDICATION]:
    QuestionnaireAnswerType.STRING,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TYPE]:
    QuestionnaireAnswerType.STRING,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INSTRUCTION]:
    QuestionnaireAnswerType.STRING,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_PATIENT_CENTERED_GOAL]:
    QuestionnaireAnswerType.STRING,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_ADDITIONAL_DETAILS]:
    QuestionnaireAnswerType.STRING,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_VISITS]:
    QuestionnaireAnswerType.INTEGER,
  [PlanOfCareQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_FREQUENCY]:
    QuestionnaireAnswerType.STRING
}
